import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from '../dialog/dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { SignLanguageVideo } from '../interfaces/sign-language-video';
import { MatRippleModule } from '@angular/material/core';
import { NgIf, NgStyle } from '@angular/common';

@Component({
  selector: 'app-sign-language',
  imports: [MatButtonModule, MatIconModule, MatRippleModule, NgStyle, NgIf],
  templateUrl: './sign-language.component.html',
  styleUrl: './sign-language.component.scss',
  standalone: true,
})
export class SignLanguageComponent {
  videos: SignLanguageVideo[] = [];
  constructor(private dialog: MatDialog) {
    this.videos = [
      {
        title: 'Hogyan adjunk fel csomagot magánszemélyként?',
        videoLink: 'https://www.youtube.com/embed/gKgjVbflUos',
        coverImage:
          'https://foxpost.hu/uploads/video/27/hogyan_adjunk_fel_csomagot_maganszemelykent.png',
        buttonLink: '/maganszemely-regisztracio',
        buttonText: 'Regisztrálok',
        layout: 'left',
      },
      {
        title: 'Hogyan vegyünk át csomagot automatából?',
        videoLink: 'https://www.youtube.com/embed/HGvWayZ4YZM',
        coverImage:
          'https://foxpost.hu/uploads/video/27/hogyan_vegynk_at_csomagot_automatabol.png',
        buttonLink: '/csomagatvetel',
        buttonText: 'Részletek',
        layout: 'right',
      },
      {
        title: 'Mi az a feladási kód?',
        videoLink: 'https://www.youtube.com/embed/Lk9XdoEG-6g',
        coverImage:
          'https://foxpost.hu/uploads/video/27/mi_az_a_feladasi_kod.png',
        buttonLink: '',
        buttonText: '',
        layout: 'left',
      },
      {
        title: 'Házhozszállítás esetén a futár feladásnál is házhoz jön?',
        videoLink: 'https://www.youtube.com/embed/NslOWSLtwLs',
        coverImage:
          'https://foxpost.hu/uploads/video/27/hazhozszallitas_eseten_a_futar_feladasnal_is_hazhoz_jn.png',
        buttonLink: '',
        buttonText: '',
        layout: 'right',
      },
      {
        title: 'Automatánál lehet készpénzzel fizetni?',
        videoLink: 'https://www.youtube.com/embed/Z1948mN1a5o',
        coverImage:
          'https://foxpost.hu/uploads/video/27/automatanal_lehet_keszpenzzel_fizetni.png',
        buttonLink: '',
        buttonText: '',
        layout: 'left',
      },
      {
        title:
          'Regisztrált FOXPOST tag vagyok. Hogyan adhatok fel csomagot FOXPOST automatával?',
        videoLink: 'https://www.youtube.com/embed/GkvueGOWJ-w',
        coverImage:
          'https://foxpost.hu/uploads/video/27/regisztralt_foxpost_tag_vagyok_hogyan_adhatok_fel_csomagot_foxpost_automataval.png',
        buttonLink: '/belepes',
        buttonText: 'Feladom a csomagom',
        layout: 'right',
      },
      {
        title: 'Hogyan adhatok fel csomagot FOXPOST házhoz szállítással?',
        videoLink: 'https://www.youtube.com/embed/JAanmiMbX2Y',
        coverImage:
          'https://foxpost.hu/uploads/video/27/hogyan_adhatok_fel_csomagot_foxpost_hazhoz_szallitassal.png',
        buttonLink: '/belepes',
        buttonText: 'CSOMAGKÜLDÉS CSOMAGAUTOMATÁBÓL HÁZHOZ SZÁLLÍTÁSSAL',
        layout: 'left',
      },
      {
        title: 'Kell-e címkét nyomtatni a csomagra?',
        videoLink: 'https://www.youtube.com/embed/22j18X0L5FM',
        coverImage:
          'https://foxpost.hu/uploads/video/27/kell_e_cimket_nyomtatni_a_csomagra.png',
        buttonLink: '',
        buttonText: '',
        layout: 'right',
      },
      {
        title: 'Egy rekeszbe rakhatok több csomagot?',
        videoLink: 'https://www.youtube.com/embed/y74FJgV_ok0',
        coverImage:
          'https://foxpost.hu/uploads/video/27/egy_rekeszbe_rakhatok_tbb_csomagot.png',
        buttonLink: '',
        buttonText: '',
        layout: 'left',
      },
      {
        title: 'Mennyi időm van átvenni a csomagom a FOXPOST automatából?',
        videoLink: 'https://www.youtube.com/embed/etUb2V1oWLU',
        coverImage:
          'https://foxpost.hu/uploads/video/27/mennyi_idm_van_atvenni_a_csomagom_a_foxpost_automatabol.png',
        buttonLink: '',
        buttonText: '',
        layout: 'right',
      },
      {
        title: 'Hogyan veheti át a címzett a csomagot?',
        videoLink: 'https://www.youtube.com/embed/LX8mDxwIjAw',
        coverImage:
          'https://foxpost.hu/uploads/video/27/hogyan_veheti_at_a_cimzett_a_csomagot.png',
        buttonLink: '',
        buttonText: '',
        layout: 'left',
      },
      {
        title: 'Utánvétes a csomagom. Hogyan tudom kifizetni?',
        videoLink: 'https://www.youtube.com/embed/nAdOjTVX9VM',
        coverImage:
          'https://foxpost.hu/uploads/video/27/utanvetes_a_csomagom_hogyan_tudom_kifizetni.png',
        buttonLink: '',
        buttonText: '',
        layout: 'right',
      },
      {
        title: 'Tudok utánvéttel csomagot küldeni?',
        videoLink: 'https://www.youtube.com/embed/NmNhqO6aBO8',
        coverImage:
          'https://foxpost.hu/uploads/video/27/tudok_utanvettel_csomagot_kldeni.png',
        buttonLink: '',
        buttonText: '',
        layout: 'left',
      },
      {
        title:
          'Webáruházból rendelt termékemet hogyan tudom visszaküldeni FOXPOST-tal?',
        videoLink: 'https://www.youtube.com/embed/2c1IquG_b50',
        coverImage:
          'https://foxpost.hu/uploads/video/27/webaruhazbol_rendelt_termekemet_hogyan_tudom_visszakldeni_foxpost_tal.png',
        buttonLink: '/belepes',
        buttonText: 'VISSZAKÜLDÖM CSOMAGOM',
        layout: 'right',
      },
      {
        title:
          'Webáruházból rendeltem FOXPOST automatába, de nem tetszik a termék. Hogyan küldhetem vissza?',
        videoLink: 'https://www.youtube.com/embed/pi16QhBR9vQ',
        coverImage:
          'https://foxpost.hu/uploads/video/27/webaruhazbol_rendeltem_es_nem_foxpost_automatabol_hanem_egyeb_modon_vettem_at_nem_tetszik_a_termek_hogyan_kldhetem_vissza.png',
        buttonLink: '/belepes',
        buttonText: 'VISSZAKÜLDÖM CSOMAGOM',
        layout: 'left',
      },
      {
        title:
          'Webáruházból rendeltem és nem FOXPOST automatából, hanem egyéb módon vettem át. Nem tetszik a termék. Hogyan küldhetem vissza?',
        videoLink: 'https://www.youtube.com/embed/ljFP_fG6-yQ',
        coverImage:
          'https://foxpost.hu/uploads/video/27/webaruhazbol_rendeltem_foxpost_automataba_de_nem_tetszik_a_termek_hogyan_kldhetem_vissza.png',
        buttonLink: '/belepes',
        buttonText: 'VISSZAKÜLDÖM CSOMAGOM',
        layout: 'right',
      },
      {
        title: 'Hogyan kaphatok kupont?',
        videoLink: 'https://www.youtube.com/embed/5GGwdPPNQDc',
        coverImage:
          'https://foxpost.hu/uploads/video/27/hogyan_kaphatok_kupont.png',
        buttonLink: '',
        buttonText: '',
        layout: 'left',
      },
      {
        title: 'Hogyan tudom elindítani az applikációból a csomagátvételt?',
        videoLink: 'https://www.youtube.com/embed/Bz9XJTkNx18',
        coverImage:
          'https://foxpost.hu/uploads/video/27/hogyan_tudom_elinditani_az_applikaciobol_a_csomagatvetelt.png',
        buttonLink: '',
        buttonText: '',
        layout: 'right',
      },
      {
        title: 'Kárigény bejelentés sérült csomaghoz',
        videoLink: 'https://www.youtube.com/embed/EGT0qZrR28Y',
        coverImage:
          'https://foxpost.hu/uploads/video/27/karigeny_bejelentes_serlt_csomaghoz.png',
        buttonLink: '/ugyfelszolgalat/csomagkuldes/serult-csomag',
        buttonText: 'Kárigény benyújtása',
        layout: 'left',
      },
      {
        title: 'Téves díjlevonás az automatánál',
        videoLink: 'https://www.youtube.com/embed/F45LiOXpkzI',
        coverImage:
          'https://foxpost.hu/uploads/video/27/teves_dijlevonas_az_automatanal.png',
        buttonLink: '/ugyfelszolgalat/csomagautomata2',
        buttonText: 'Bejelentés',
        layout: 'right',
      },
      {
        title: 'foxpost.hu csomagküldéssel kapcsolatos probléma',
        videoLink: 'https://www.youtube.com/embed/xBoh5fIlnIs',
        coverImage:
          'https://foxpost.hu/uploads/video/27/foxposthu_csomagkldessel_kapcsolatos_problema.png',
        buttonLink: '/ugyfelszolgalat/csomagvarazslo/',
        buttonText: 'Probléma bejelentése',
        layout: 'left',
      },
    ];
  }
  openDialog(title: String, videoLink: String) {
    const dialogRef = this.dialog.open(DialogComponent, {
      minWidth: '50vw',
      data: {
        title: title,
        videoLink: videoLink,
      },
    });
  }
}
